/* eslint-disable eqeqeq */
import axios from 'axios'
import i18next from 'i18next'
import React, {useCallback, useEffect, useState} from 'react'
import {Spinner} from 'react-bootstrap'
import Button from 'react-bootstrap/Button'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import Row from 'react-bootstrap/Row'
import {useTranslation} from 'react-i18next'
import {useNavigate} from 'react-router-dom'
import swal from 'sweetalert'
import {KTSVG} from '../../../_metronic/helpers'
import {getAccessSip} from '../../../api/modules/approval/approval'
import {create, deleteFile, getFile} from '../../../api/modules/file'
import {getSalesAreaLetter} from '../../../api/modules/getdatalist'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {resetFilter, sipSelector} from '../../../redux/slices/sipSlices'
import Pagination from '../component/Pagination'
import CustomUseEffect from './../so/CustomUseEffect'
import AddRemoveJadwal from './AddRemoveJadwal'
import ButtonGroups from './ButtonGroups'
import RowFilter from './RowFilter'
import RowHead from './RowHead'
import {PopoverText} from '../../../components/Popover/Popover'
import {objToParams} from '../../../utils/objToParams'
import {fetchSIPApproval, headers} from '../../../services/fetcher'
import {DocFlow} from '../../../components/DocFlow'
import {getRoleFlagList} from '../../../api/modules/master-data/master_2'
import {MultiSelect} from 'react-multi-select-component'
import * as TableUI from '../../../components/Table/Table'
import {useRowTable} from '../../../hooks/useRowTable'
import {StyledCard} from '../../../components/StyledCard'
import {PriceFormater} from '../../../components/mikro/PriceFormater'
import {appSelector} from '../../../redux/slices/appSlices'
import {unduhSIP} from '../../../api/modules/sip'
import {HakAkses} from '../../../components/mikro/getHakAkses'
import {authSelector} from 'src/redux/slices/authSlices'
import {BadgeColorSIP} from 'src/components/BadgeColorSIP'
import dateformat from 'src/utils/dateformat'
import {FieldProductSpec} from 'src/components/FieldProductSpec'
import {CheckSameIDAttachment} from 'src/components/mikro/CheckSameIDAttachment'
import Skeleton from 'react-loading-skeleton'
import {setIsFetchData} from 'src/redux/slices/filterSlices'
import { SIPHistories } from '../si/SIPHistories'
import ListHistorySIP from '../si/ListHistorySIP'
import { InputFile } from 'src/app/components/InputFile'
import { handleDownloadAttachment } from 'src/app/helpers/file'

type Props = {
  className: string
}

const ApprovalTableSIP: React.FC<Props> = ({className}) => {
  const [tooltip, setTooltip] = useState('Open')
  const {filter} = useAppSelector(sipSelector)
  const {roleId} = useAppSelector(authSelector)
  const dispatch = useAppDispatch()

  const hakAkses = HakAkses()
  const {RowEmptyData, RowErrorFetch, RowLoader} = useRowTable({
    colSpan: 14,
    onReloadTable: () => handleReloadTable(),
  })

  const handleOpen = (e: any) => {
    const icon = e.target
    if (icon.classList.contains('iconArow')) {
      icon?.classList.remove('iconArow')
      icon?.classList.add('iconArowOpen')
      setTooltip('Close')
    } else {
      icon?.classList.remove('iconArowOpen')
      icon?.classList.add('iconArow')
      setTooltip('Open')
    }
    const target = e.currentTarget.getAttribute('data-target')
    const fold = document.getElementById(target)
    fold?.classList.toggle('fold-open')
  }

  const handleShow = (id: any) => {
    sessionStorage.setItem('SI_ID', id)

    navigate(`/approval/sip/detail/${id}`)
  }

  const navigate = useNavigate()

  const {t} = useTranslation()
  const [btnLoading, setBtnLoading] = useState(false)

  const [SIP, setSIP] = useState<any[]>([])
  const [loading, setLoading] = useState(false)
  const [isFailed, setIsFailed] = useState(false)
  const [numberURL, setNumberURL] = useState([])
  const [showJadwal, setShowJadwal] = useState(false)
  const [jadwalID, setJadwalID] = useState('')
  const [roleUser, setRoleUser] = useState('')
  const [idOrder, setIDOrder] = useState('')
  const [showUpload, setShowUpload] = useState(false)
  const [allFiles, setAllFiles] = useState<any[]>([])
  const [files, setFiles] = useState({file: null})
  const [namaFile, setNamaFile] = useState('')
  const [description, setDescription] = useState('')
  const [isPrivate, setIsPrivate] = useState(false)
  const [dataType, setDataType] = useState('')
  const [param, setParam] = useState('')
  const [idSektor, setIDSector] = useState(0)
  const [language, setLanguage] = useState<any>()
  const [isChecked, setIsChecked] = useState(false)
  const [SIPNumber, setSIPNumber] = useState(null)
  const [tempRole, setTempRole] = useState<any[]>([])
  const [fullRole, setFullRole] = useState<any[]>([])
  const [fileBox, setFileBox] = useState<any>({})
  const [isLoadingModal, setIsLoadingModal] = useState(false)
  const [showHistory, setShowHistory] = useState<any>()
  const [showModalHistory, setShowModalHistory] = useState(false)
  const [showListHistorySIP, setShowListHistorySIP] = useState(false)

  const dateFormatting = (date: any) => {
    let today = new Date(date)
    let dd = String(today.getDate()).padStart(2, '0')
    let mm = String(today.getMonth() + 1).padStart(2, '0') //January is 0!
    let yyyy = today.getFullYear()
    return dd + '-' + mm + '-' + yyyy
  }

  useEffect(() => {
    const interval = setInterval(() => {
      const getCookie = (name: string) => {
        const value = `; ${document.cookie}`
        const parts = value.split(`; ${name}=`)
        if (parts.length === 2) return parts.pop()?.split('~#~').shift()
      }
      let language = getCookie('i18next')
      setLanguage(language)
    }, 1000)
    return () => clearInterval(interval)
  }, [])

  const oncFetchSIPApproval = useCallback(() => {
    setLoading(true)
    setIsFailed(false)
    const checked = isChecked ? '-approved' : ''
    fetchSIPApproval(checked, filter)
      .then((res) => {
        setSIP(res.data.data.data)
        setNumberURL(res.data.data.links)
      })
      .catch(() => setIsFailed(true))
      .finally(() => setLoading(false))
  }, [filter, isChecked])

  const [accesses, setAccesses] = useState<any>()
  const [salesOrg, setSalesOrg] = useState<any>()
  const [provinceName, setProvinceName] = useState('')
  const [cityName, setCityName] = useState('')
  const [productName, setProductName] = useState('')
  const [requestQuantum, setReqeustQuantum] = useState('')
  const [fixedQuantum, setFixedQuantum] = useState('')

  const formattingTon = (ton: any) => {
    let tempTon = parseFloat(ton)
    let temp = ''
    if (i18next.language == 'en') {
      temp = tempTon.toLocaleString('en', {maximumFractionDigits: 4})
    } else {
      temp = tempTon.toLocaleString('id', {maximumFractionDigits: 4})
    }

    setFixedQuantum(temp)
  }

  useEffect(() => {
    const role = () => {
      const role: any = localStorage.getItem('role-flag')
      setRoleUser(role)
    }

    const getAccessMenu = async () => {
      setLoading(true)
      const res = await getAccessSip(roleId)
      setAccesses(res.data.data)
    }

    const getSalesOrg = async () => {
      const res = await getSalesAreaLetter()
      setSalesOrg(res.data.data)
    }

    const getAllRoleList = async () => {
      const res = await getRoleFlagList()
      setFullRole(res.data.data)
    }

    getSalesOrg()
    getAccessMenu()
    role()
    getAllRoleList()
  }, [])

  const ambilAttachment = async () => {
    await getFile(param, idOrder, localStorage.getItem('credential')!).then((res) => {
      setAllFiles(res.data.data)
      setShowUpload(true)
    })
  }

  const tampilUpload = async (id: any, paramm: any) => {
    setIDOrder(id)
    await getFile(paramm, id, localStorage.getItem('credential')!).then((res) => {
      setAllFiles(res.data.data)
      setIsLoadingModal(false)
    })
  }

  const clearFile = () => {
    const inputfile = document.getElementById('upload') as HTMLInputElement
    inputfile.value = ''
    const inputPrivate = document.getElementById('isPrivate') as HTMLInputElement
    inputPrivate.checked = false
  }

  const deleteAttachment = async (id: any) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Yes')}`],
      dangerMode: true,
    }).then(async (del) => {
      if (del) {
        await deleteFile(id)
          .then(() => {
            swal({
              closeOnClickOutside: false,
              title: t('Dokumen Berhasil Dihapus'),
              icon: 'success',
            })
            ambilAttachment()
          })
          .catch((error) => {
            swal({
              title: error.response.data,
              icon: 'error',
            })
          })
      }
    })
  }

  const handleUpload = async () => {
    setBtnLoading(true)
    let file = files.file
    let formdata = new FormData()
    let temparray: any[] = []
    if (tempRole.length > 0) {
      tempRole.forEach((data: any) => {
        temparray.push(data.value)
      })
    }
    formdata.append('file_r', file!)
    formdata.append('name', namaFile!)
    formdata.append('description', description!)
    formdata.append('attach_parent', idOrder)
    formdata.append('private', isPrivate.toString())
    formdata.append('file_type', dataType)
    formdata.append('roles', JSON.stringify(temparray))
    if (SIPNumber) {
      formdata.append('unique_number', SIPNumber)
      formdata.append('unique_flag', 'new_sip_osd')
    }
    formdata.append('credentials', localStorage.getItem('credential')!)
    // console.log(formdata)
    await create(param, formdata)
      .then((res) => {
        swal({
          title: `${t('document uploaded successfully')}`,
          icon: 'success',
        }).then(() => {
          setNamaFile('')
          setDescription('')
          setDataType('')
          setIsPrivate(false)
          setFiles({file: null})
          setTempRole([])
          clearFile()
        })
        ambilAttachment()
      })
      .catch((error) => {
        swal({
          title: t(error.response.data.message),
          icon: 'error',
        })
      })
      .finally(() => setBtnLoading(false))
  }

  const paginateNumber = async (url: string) => {
    if (!url) return

    const token = localStorage.getItem('token') as string
    const credentials = localStorage.getItem('credential') as string
    const endpoint = `${url}&credentials=${credentials}&${objToParams(filter)}`
    const res = await axios.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})

    setSIP(res.data.data.data)
    setNumberURL(res.data.data.links)
  }

  useEffect(() => {
    const getData = setTimeout(() => oncFetchSIPApproval(), 1000)
    return () => clearTimeout(getData)
  }, [oncFetchSIPApproval])

  const [showDetail, setShowDetail] = useState(false)

  const [detaill, setDetail] = useState<any>([])

  const [checked, setChecked] = useState<any>('')

  CustomUseEffect(() => {
    let tempchecked = false
    if (checked?.id != null || checked != '')
      if (checked?.id == 'yes' || checked == 'yes') {
        setIsChecked(true)
        tempchecked = true
        // console.log('true checked')
      } else {
        setIsChecked(false)
        tempchecked = false
        // console.log('false checked')
      }
    // getOrder(tempchecked)
  }, [checked])

  const handleShowValue = (enduser: any) => {
    let temparray: any[] = enduser.split(',')
    let temp = ''
    temparray.forEach((element: any, index: any) => {
      if (index + 1 == temparray.length) temp = temp + element
      else temp = temp + element + ', '
    })
    return temp
  }

  const handleReloadTable = () => {
    dispatch(resetFilter())
    dispatch(setIsFetchData(false))
    oncFetchSIPApproval()
  }

  function handleShowRoleName(role: any) {
    let temp = ''
    role.forEach((element: any, index: any) => {
      if (index + 1 == role.length) temp = temp + element
      else temp = temp + element + ', '
    })
    return temp
  }

  const handleCheckFile = (url: any) => {
    axios
      .get(url)
      .then((response) => {
        window.open(url)
      })
      .catch((error) => {
        swal({
          title: t(error.response.data.message),
          icon: 'error',
        })
      })
  }

  const handleUnduh = async (id: any) => {
    await unduhSIP(id, i18next.language)
      .then((res: any) => {
        handleCheckFile(
          `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/sip_order/sip/print/${id}?lang=${
            i18next.language
          }&token=${localStorage.getItem('token')}`
        )
      })
      .catch((err: any) => {})
  }

  return (
    <StyledCard>
      <ButtonGroups onCheckedChange={(target) => setChecked(target)} />

      <TableUI.TableWrapper>
        <TableUI.Table>
          <TableUI.THead>
            <RowHead />
          </TableUI.THead>
          <TableUI.TBody>
            <RowFilter />
            {loading ? (
              <RowLoader />
            ) : isFailed ? (
              <RowErrorFetch />
            ) : SIP?.length === 0 ? (
              <RowEmptyData />
            ) : (
              SIP.map((item, _index) => (
                <>
                  <tr>
                    <td>
                      <div
                        className='d-flex justify-content-center align-items-center'
                        style={{marginTop: '2.5px', marginBottom: '3px'}}
                      >
                        <button
                          className='iconArow d-flex justify-content-center align-items-center me-2'
                          data-target={'target' + item['SIP_number']}
                          title={t(tooltip)}
                          onClick={handleOpen}
                        ></button>
                        <span
                          className='fw-semibold cursor-pointer'
                          style={{color: '#274070'}}
                          onClick={() => handleShow(item['id'])}
                        >
                          11{item['SIP_number']}
                        </span>
                      </div>
                    </td>
                    <td>
                      <span>10{item['pengajuan_order']?.po_number}</span>
                    </td>
                    <td>
                      <PopoverText
                        content={
                          item['customer']?.title == null || item['customer']?.title == ''
                            ? item['customer']?.name
                            : item['customer']?.title + ' ' + item['customer']?.name
                        }
                        index={_index}
                        className='desc-slicee'
                      />
                    </td>
                    <td>
                      {item['perihal'] == 'PO001' ? (
                        <span className='badge badge-light-success'>{t('penjualan')}</span>
                      ) : (
                        <span className='badge badge-light-primary'>{t('Non-penjualan')}</span>
                      )}
                    </td>
                    <td>
                      <span>{t(item.sector?.name)}</span>
                    </td>
                    <td>
                      <span>{item['anper']?.name}</span>
                    </td>
                    <td>
                      <span>{dateformat(item.created_at)}</span>
                    </td>
                    <td>
                      <span>{dateformat(item.estimate_date)}</span>
                    </td>
                    <td>
                      <span>
                        {item.valid_date_from == null ? '' : dateformat(item.valid_date_from)}
                      </span>
                    </td>
                    <td>
                      <span>
                        {item.valid_date_to == null ? '' : dateformat(item.valid_date_to)}
                      </span>
                    </td>
                    <td>
                      <span>
                        {i18next.language === 'en'
                          ? item.total_quantum?.toLocaleString('en', {
                              maximumFractionDigits: 4,
                            })
                          : item.total_quantum?.toLocaleString('id', {
                              maximumFractionDigits: 4,
                            })}{' '}
                        {item.sector_id != 3 ? 'Ton' : 'MT'}
                      </span>
                    </td>
                    {item.sector_id != 3 ? (
                      <td>
                        <span>
                          {'Rp' + i18next.language === 'en'
                            ? item.total_price?.toLocaleString('en', {maximumFractionDigits: 4})
                            : item.total_price?.toLocaleString('id', {maximumFractionDigits: 4})}
                        </span>
                      </td>
                    ) : (
                      <td>
                        <span>USD {PriceFormater(item.total_price)}</span>
                      </td>
                    )}
                    <td>
                      <BadgeColorSIP status={item.status} text={item.status_text} type='header' />
                    </td>
                    <td>
                      <div
                        className='d-flex p-0 justify-content-center'
                        style={{marginTop: '1.3px', marginBottom: '1px'}}
                      >
                        {hakAkses?.approve && (
                          <button
                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                            title='Detail'
                            onClick={() => handleShow(item['id'])}
                          >
                            <KTSVG
                              path='/media/icons/duotune/file-text-fill.svg'
                              className='svg-icon-3'
                            />
                          </button>
                        )}

                        <button
                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                          onClick={() => {
                            setIsLoadingModal(true)
                            setShowUpload(true)
                            tampilUpload(item.id, 'sip')
                            setParam('sip')
                            setIDSector(item?.sector?.id)
                          }}
                          title={t('order-lampiran')}
                        >
                          <KTSVG
                            path='/media/icons/duotune/archive-fill.svg'
                            className='svg-icon-3'
                          />
                        </button>

                        {(item.document != null || item.file_path != null) &&
                          !(item.status == 1 || item.status == 2 || item.status == 3 || item.status == 99) && (
                            <button
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t('unduh sip')}
                                hidden={hakAkses?.print ? false : true}
                                onClick={() => {
                                  setShowHistory(item.id)
                                  setShowModalHistory(true)
                                }}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/file-earmark-arrow-down-fill.svg'
                                  className='svg-icon-3'
                                />
                            </button>
                          )}

                            <button
                              onClick={() => {
                                setShowHistory(item.id)
                                setShowListHistorySIP(true)
                              }}
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title={t('Histori SIP')}
                            >
                              <KTSVG path='/media/icons/duotune/clock.svg' className='svg-icon-3' />
                          </button>
                      </div>
                    </td>
                  </tr>

                  <tr className='fold' id={'target' + item['SIP_number']}>
                    <TableUI.TableDetail colSpan={14}>
                      <TableUI.TableWrapper style={{marginBottom: 0}}>
                        <TableUI.Table>
                          <TableUI.THead>
                            <tr style={{backgroundColor: '#274070'}}>
                              <th>{t('sub-order-item')}</th>
                              {item.customer?.customer_account_group != 'AR03' ? (
                                <>
                                  <th>Sales Org</th>
                                  <th>{t('sub-order-incoterm')}</th>
                                  <th>{t('sub-order-wilayah')}</th>
                                  <th>{t('sub-order-jenis')}</th>
                                  <th>{t('Product Code')}</th>
                                  <th>{t('sub-order-produk')}</th>
                                  <th>{t('sub-order-spek')}</th>
                                  {item?.sector.id != 2 ? (
                                    <>
                                      <th>{t('kontrak-kuantum')}</th>
                                      <th>{t('sub-order-kuantumD')}</th>
                                      <th>{t('kontrak-harga')}</th>
                                      <th>{t('sub-order-hargaD')}</th>
                                    </>
                                  ) : (
                                    <>
                                      <th>{t('kontrak-kuantum')}</th>
                                      <th>{t('kontrak-harga')}</th>
                                    </>
                                  )}
                                </>
                              ) : (
                                <>
                                  <th>Sales Org</th>
                                  <th>{t('sub-order-incoterm')}</th>
                                  <th>{t('sub-order-wilayah')}</th>
                                  <th>{t('sub-order-jenis')}</th>
                                  <th>{t('Product Code')}</th>
                                  <th>{t('sub-order-produk')}</th>
                                  <th>{t('sub-order-spek')}</th>

                                  {item?.sector.id != 2 ? (
                                    <>
                                      <th>{t('kontrak-kuantum')}</th>
                                      <th>{t('sub-order-kuantumD')}</th>
                                      <th>{t('kontrak-harga')}</th>
                                      <th>{t('sub-order-hargaD')}</th>
                                    </>
                                  ) : (
                                    <>
                                      <th>{t('kontrak-kuantum')}</th>
                                      <th>{t('kontrak-harga')}</th>
                                    </>
                                  )}
                                </>
                              )}

                              {(item.sector?.id == 1 || item.sector?.id == 3) && (
                                <th>{t('sub-order-gudang')}</th>
                              )}
                              <th>Status</th>
                              <th>{t('order-aksi')}</th>
                            </tr>
                          </TableUI.THead>
                          <TableUI.TBody>
                            {item?.order_sub_details?.map((subItem: any, _index: number) => (
                              <tr key={subItem?.id ?? _index}>
                                <td>{subItem.id}</td>
                                <td>{subItem.produsen?.name}</td>
                                {subItem.sector_id == 2 ? (
                                  <>
                                    {subItem.incoterm2 == null ? (
                                      <td>
                                        {subItem.incoterm1?.code}-{subItem.incoterm2_id}
                                      </td>
                                    ) : (
                                      <td>
                                        {subItem.incoterm1?.code}-{subItem.incoterm2?.code}
                                      </td>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {subItem.incoterm2 == null ? (
                                      <td>
                                        {subItem.incoterm1?.code}
                                        {subItem.incoterm2_id == null || subItem.incoterm2_id == '0'
                                          ? ''
                                          : '-' + subItem.incoterm2_id}
                                      </td>
                                    ) : (
                                      <td>
                                        {subItem.incoterm1?.code}-{subItem.incoterm2?.code}
                                      </td>
                                    )}
                                  </>
                                )}
                                <td>
                                  {subItem.province?.region_name}
                                  {subItem.city?.city_name ? ', ' + subItem.city?.city_name : ''}
                                </td>
                                <td>{subItem.product_type_desc}</td>
                                <td>
                                  {parseInt(subItem.material_number) == 0
                                    ? ''
                                    : subItem.material_number?.slice(-7)}
                                </td>
                                <td>{subItem.product_name}</td>
                                <td>
                                  <PopoverText
                                    content={subItem.product_spec}
                                    index={_index}
                                    className='spec-slice'
                                  />
                                </td>
                                {item.customer?.customer_account_group != 'AR03' ? (
                                  <>
                                    {subItem.sector_id != 2 ? (
                                      <td>
                                        {i18next.language === 'en'
                                          ? subItem.request_quantum?.toLocaleString('en', {
                                              maximumFractionDigits: 4,
                                            })
                                          : subItem.request_quantum?.toLocaleString('id', {
                                              maximumFractionDigits: 4,
                                            })}{' '}
                                        {subItem.sector_id != 3 ? 'Ton' : 'MT'}
                                      </td>
                                    ) : (
                                      <></>
                                    )}

                                    <td>
                                      {i18next.language === 'en'
                                        ? subItem.fixed_quantum?.toLocaleString('en', {
                                            maximumFractionDigits: 4,
                                          })
                                        : subItem.fixed_quantum?.toLocaleString('id', {
                                            maximumFractionDigits: 4,
                                          })}{' '}
                                      {subItem.sector_id != 3 ? 'Ton' : 'MT'}
                                    </td>

                                    {subItem.sector_id != 2 && (
                                      <>
                                        {subItem.is_formulated_price ? (
                                          <>
                                            <td>{t('Formulated Price')}</td>
                                          </>
                                        ) : (
                                          <>
                                            {subItem.sector_id == 1 ? (
                                              <td>
                                                {'Rp' + i18next.language === 'en'
                                                  ? subItem.request_price?.toLocaleString('en', {
                                                      maximumFractionDigits: 4,
                                                    })
                                                  : subItem.request_price?.toLocaleString('id', {
                                                      maximumFractionDigits: 4,
                                                    })}
                                                /Ton
                                              </td>
                                            ) : (
                                              <td>
                                                USD {PriceFormater(subItem.request_price)} /MT
                                              </td>
                                            )}
                                          </>
                                        )}
                                      </>
                                    )}

                                    {subItem.sector_id != 3 ? (
                                      <td>
                                        {'Rp' + i18next.language === 'en'
                                          ? subItem.fixed_price?.toLocaleString('en', {
                                              maximumFractionDigits: 4,
                                            })
                                          : subItem.fixed_price?.toLocaleString('id', {
                                              maximumFractionDigits: 4,
                                            })}
                                        /Ton
                                      </td>
                                    ) : (
                                      <td>USD {PriceFormater(subItem.fixed_price)} /MT</td>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {subItem.sector_id != 2 && (
                                      <td>
                                        {i18next.language === 'en'
                                          ? subItem.request_quantum?.toLocaleString('en', {
                                              maximumFractionDigits: 4,
                                            })
                                          : subItem.request_quantum?.toLocaleString('id', {
                                              maximumFractionDigits: 4,
                                            })}{' '}
                                        {subItem.sector_id != 3 ? 'Ton' : 'MT'}
                                      </td>
                                    )}

                                    <td>
                                      {i18next.language === 'en'
                                        ? subItem.fixed_quantum?.toLocaleString('en', {
                                            maximumFractionDigits: 4,
                                          })
                                        : subItem.fixed_quantum?.toLocaleString('id', {
                                            maximumFractionDigits: 4,
                                          })}{' '}
                                      {subItem.sector_id != 3 ? 'Ton' : 'MT'}
                                    </td>

                                    {subItem.sector_id != 2 && (
                                      <>
                                        {subItem.is_formulated_price ? (
                                          <>
                                            <td>{t('Formulated Price')}</td>
                                          </>
                                        ) : (
                                          <>
                                            {subItem.sector_id == 1 ? (
                                              <td>
                                                {'Rp' + i18next.language === 'en'
                                                  ? subItem.request_price?.toLocaleString('en', {
                                                      maximumFractionDigits: 4,
                                                    })
                                                  : subItem.request_price?.toLocaleString('id', {
                                                      maximumFractionDigits: 4,
                                                    })}
                                                /Ton
                                              </td>
                                            ) : (
                                              <td>
                                                USD {PriceFormater(subItem.request_price)} /MT
                                              </td>
                                            )}
                                          </>
                                        )}
                                      </>
                                    )}

                                    {subItem.sector_id != 3 ? (
                                      <td>
                                        {'Rp' + i18next.language === 'en'
                                          ? subItem.fixed_price?.toLocaleString('en', {
                                              maximumFractionDigits: 4,
                                            })
                                          : subItem.fixed_price?.toLocaleString('id', {
                                              maximumFractionDigits: 4,
                                            })}
                                        /Ton
                                      </td>
                                    ) : (
                                      <td>USD {PriceFormater(subItem.fixed_price)} /MT</td>
                                    )}
                                  </>
                                )}
                                {(item.sector?.id == 1 || item.sector?.id == 3) && (
                                  <td>{subItem.plant_desc}</td>
                                )}
                                <td>
                                  <BadgeColorSIP
                                    status={subItem?.status_sip}
                                    text={subItem?.status_text_sip}
                                    type='item'
                                  />
                                </td>
                                <td>
                                  <div className='d-flex justify-content-center align-items-center'>
                                    <button
                                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                      title='Detail'
                                      onClick={() => {
                                        setDetail(subItem)
                                        setShowDetail(true)
                                      }}
                                    >
                                      <KTSVG
                                        path='/media/icons/duotune/file-text-fill.svg'
                                        className='svg-icon-3'
                                      />
                                    </button>
                                    <button
                                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                      title={t('order-lampiran')}
                                      onClick={() => {
                                        setIsLoadingModal(true)
                                        setShowUpload(true)
                                        tampilUpload(
                                          subItem.order_sub_item_id == null
                                            ? subItem.id
                                            : subItem?.order_sub_item_id,
                                          'order-item'
                                        )
                                        setParam('order-item')
                                        setSIPNumber(item.SIP_number)
                                        setFileBox(subItem)
                                      }}
                                    >
                                      <KTSVG
                                        path='/media/icons/duotune/archive-fill.svg'
                                        className='svg-icon-3'
                                      />
                                    </button>
                                    <button
                                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                      title={t('Jadwal')}
                                      onClick={() => {
                                        setIDSector(subItem.sector_id)
                                        setProvinceName(subItem.province?.region_name)
                                        setCityName(subItem.city?.city_name)
                                        setProductName(subItem.product_name)
                                        formattingTon(subItem.fixed_quantum)
                                        setReqeustQuantum(subItem.request_quantum)
                                        setJadwalID(
                                          subItem.order_sub_item_id == null
                                            ? subItem.id
                                            : subItem?.order_sub_item_id
                                        )
                                        setShowJadwal(true)
                                      }}
                                    >
                                      <KTSVG
                                        path='/media/icons/duotune/calendar-check-fill.svg'
                                        className='svg-icon-3'
                                      />
                                    </button>
                                    <DocFlow
                                      id={
                                        subItem.order_sub_item_id == null
                                          ? subItem?.id
                                          : subItem?.order_sub_item_id
                                      }
                                    />
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </TableUI.TBody>
                        </TableUI.Table>
                      </TableUI.TableWrapper>
                    </TableUI.TableDetail>
                  </tr>
                </>
              ))
            )}
          </TableUI.TBody>
        </TableUI.Table>
      </TableUI.TableWrapper>

      <Pagination paginate={paginateNumber} test={numberURL} />

      <Modal
        show={showJadwal}
        onHide={() => {
          setShowJadwal(false)
          setJadwalID('')
        }}
        centered
        size='xl'
        backdrop='static'
        keyboard={false}
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {idSektor != 3 ? provinceName + ', ' + cityName + ' | ' : ''}
            {productName} | {fixedQuantum} Ton
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <span style={{fontSize: '15px'}} className='fw-bold d-block'>
            {t('Jadwal')}
          </span>
          <AddRemoveJadwal id={jadwalID} is_amendment={false} />
        </Modal.Body>
      </Modal>

      <Modal
        size='lg'
        show={showUpload}
        onHide={() => {
          setShowUpload(false)
          setSIPNumber(null)
          setFileBox({})
        }}
        backdrop='static'
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {fileBox?.product_name
              ? (fileBox.province ? fileBox.province?.region_name : '') +
                (fileBox.city ? ', ' + fileBox.city?.city_name : '') +
                (fileBox.province ? ' | ' : '') +
                fileBox.product_name +
                (fileBox.request_quantum ? ' | ' + fileBox.request_quantum + ' Ton' : '')
              : t('File Box')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isLoadingModal ? (
            <Skeleton width={100} height={30} />
          ) : (
            <>
              <Row>
                <Col sm={6}>
                  <table className='mb-3'>
                    <tr>
                      <td style={{width: '120px'}}>
                        <h6>{t('order-fileUnggah')}</h6>
                      </td>
                      <td className='w-75'>
                        <InputFile
                            setFileName={setNamaFile}
                            setFiles={setFiles}
                            isBase64={false}
                        />
                      </td>
                    </tr>
                  </table>
                  <table className='mb-3'>
                    <tr>
                      <td style={{width: '120px'}}>
                        <h6>{t('order-keterangan')}</h6>
                      </td>
                      <td className='w-75'>
                        <Form.Control
                          type='text'
                          placeholder={t('order-keterangan')}
                          onChange={(e: any) => setDescription(e.target.value)}
                          value={description}
                        />
                      </td>
                    </tr>
                  </table>
                  <table className='mb-3'>
                    <tr>
                      <td>
                        <h6 className='me-11'>{t('Private')}</h6>
                      </td>
                      <td className='w-75 d-flex justify-content-start'>
                        <Form.Check
                          reverse
                          name='isPrivate'
                          type='checkbox'
                          className='mt-5 mb-2'
                          onClick={() => {
                            setIsPrivate(!isPrivate)
                          }}
                          id='isPrivate'
                        />
                      </td>
                    </tr>
                  </table>
                  <table className='mb-3' hidden={isPrivate ? false : true}>
                    <tr>
                      <td style={{width: '120px'}}>
                        <h6>{t('Akses Role')}</h6>
                      </td>
                      <td className='w-75' style={{maxWidth: '274px'}}>
                        <MultiSelect
                          key={isPrivate.toString()}
                          options={fullRole?.map((item: any) => {
                            return {label: item.label, value: item.value}
                          })}
                          value={tempRole}
                          onChange={(e: any) => setTempRole(e)}
                          labelledBy='Select'
                        />
                      </td>
                    </tr>
                  </table>
                  <div className='d-flex justify-content-end'>
                    <Button
                      variant='primary'
                      className='w-100'
                      onClick={() => handleUpload()}
                      disabled={btnLoading}
                    >
                      {btnLoading ? (
                        <Spinner animation='border' variant='light' size='sm' />
                      ) : (
                        t('order-kirim')
                      )}
                    </Button>
                  </div>
                </Col>
              </Row>
              <div className='table-responsive mt-4 bdr'>
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                  <thead className='fw-bold border-bottom'>
                    <tr className=''>
                      <th className='text-center'>{t('order-noo')}</th>
                      <th className='text-center'>{t('order-keterangan')}</th>
                      <th className='text-center'>{t('order-tglUpload')}</th>
                      {/* <th className='text-center'>{t('User Code')}</th> */}
                      <th className='text-center'>{t('order-user')}</th>
                      <th className='text-center'>{t('Akses Role')}</th>
                      <th className='text-center'>{t('order-aksi')}</th>
                    </tr>
                  </thead>
                  {allFiles.map((data: any, _index: number) => (
                    <tbody key={data?.id ?? _index}>
                      <tr className=''>
                        <td className='text-center'>
                          <label>{_index + 1}</label>
                        </td>
                        <td className='text-center'>
                          <label>{data.description}</label>
                        </td>
                        <td className='text-center'>
                          <label>{dateformat(data.updated_at)}</label>
                        </td>
                        {/* <td className='text-center'>
                          <label>{data.user?.customer_code || data.user?.nama_pengguna}</label>
                        </td> */}
                        <td className='text-center'>
                          {data.user?.customer != null ? (
                            <label>{data.user?.customer?.name}</label>
                          ) : (
                            <label>{data.user?.name}</label>
                          )}
                        </td>
                        <td className='text-center'>
                          {data.private ? (
                            data.roles.length > 0 ? (
                              <PopoverText
                                content={handleShowRoleName(data.roles)}
                                index={_index}
                                className='desc-slice'
                              />
                            ) : (
                              'Private'
                            )
                          ) : (
                            'Public'
                          )}
                        </td>
                        <td className='text-center'>
                          <button
                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                            data-bs-toggle='tooltip'
                            data-bs-placement='top'
                            data-bs-trigger='hover'
                            title={t('unduh')}
                            onClick={() =>
                              handleDownloadAttachment(
                                data.file_path
                              )
                            }
                          >
                            <KTSVG
                              path='/media/icons/duotune/arrow-down-square-fill.svg'
                              className='svg-icon-3'
                            />
                          </button>
                          {(hakAkses?.attachment_delete ||
                            CheckSameIDAttachment(data.user_role_flag)) && (
                            <button
                              onClick={() => deleteAttachment(data.id)}
                              className={`btn btn-icon btn-bg-light btn-active-color-primary btn-sm`}
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title={t('Hapus')}
                            >
                              <KTSVG
                                path='/media/icons/duotune/trash-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>
                          )}
                        </td>
                      </tr>
                    </tbody>
                  ))}
                </table>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>

      <Modal
        show={showDetail}
        onHide={() => setShowDetail(false)}
        backdrop='static'
        keyboard={false}
        centered
        scrollable
        size='xl'
      >
        <Modal.Header closeButton>
          <Modal.Title>Detail SIP</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {detaill?.sector?.id == 1 && (
            <Row>
              <Col md='6'>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-item')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      size='sm'
                      value={detaill?.id}
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-produsen')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control value={detaill?.produsen?.name} type='text' disabled size='sm' />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      size='sm'
                      value={detaill?.incoterm1?.code}
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      size='sm'
                      value={detaill?.province?.region_name}
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      size='sm'
                      value={detaill?.product_type_desc}
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      size='sm'
                      value={
                        i18next.language === 'en'
                          ? detaill?.request_quantum?.toLocaleString('en', {
                              maximumFractionDigits: 4,
                            }) + ' Ton'
                          : detaill?.request_quantum?.toLocaleString('id', {
                              maximumFractionDigits: 4,
                            }) + ' Ton'
                      }
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('sub-order-kuantumD')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      size='sm'
                      value={
                        i18next.language === 'en'
                          ? detaill?.fixed_quantum?.toLocaleString('en', {
                              maximumFractionDigits: 4,
                            }) + ' Ton'
                          : detaill?.fixed_quantum?.toLocaleString('id', {
                              maximumFractionDigits: 4,
                            }) + ' Ton'
                      }
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      size='sm'
                      value={detaill?.payment_type_1_desc}
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('sub-order-spek')}</p>
                  </Col>
                  <Col md={8}>
                    <FieldProductSpec data={detaill?.product_spec} />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('segment')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control type='text' value={t(detaill.segment_name)} disabled size='sm' />
                  </Col>
                </Row>
              </Col>
              <Col md='6'>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-endUser')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      as='textarea'
                      size='sm'
                      style={{height: '40px'}}
                      value={
                        detaill.end_user_multiple
                          ? handleShowValue(detaill.end_user)
                          : detaill.end_user
                      }
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      size='sm'
                      value={t(detaill?.sector?.name)}
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                  </Col>
                  <Col md={8}>
                    {detaill?.incoterm2 == null ? (
                      <Form.Control
                        size='sm'
                        aria-label='Default select example'
                        value={
                          detaill?.incoterm2_id == null || detaill?.incoterm2_id == '0'
                            ? ''
                            : detaill?.incoterm2_id
                        }
                        disabled
                      />
                    ) : (
                      <Form.Control
                        aria-label='Default select example'
                        size='sm'
                        value={detaill?.incoterm2?.code ? detaill?.incoterm2?.code : ''}
                        disabled
                      />
                    )}
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      size='sm'
                      value={detaill?.city?.city_name}
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      size='sm'
                      value={detaill?.product_name}
                      disabled
                    />
                  </Col>
                </Row>

                <Row className='mb-4'>
                  <Col md={4} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('sub-order-hargaP')}/Ton</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      size='sm'
                      value={
                        'Rp' + i18next.language === 'en'
                          ? detaill?.request_price?.toLocaleString('en', {maximumFractionDigits: 4})
                          : detaill?.request_price?.toLocaleString('id', {maximumFractionDigits: 4})
                      }
                      disabled
                    />
                  </Col>
                </Row>

                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-hargaD')}/Ton</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      size='sm'
                      value={
                        'Rp' + i18next.language === 'en'
                          ? detaill?.fixed_price?.toLocaleString('en', {maximumFractionDigits: 4})
                          : detaill?.fixed_price?.toLocaleString('id', {maximumFractionDigits: 4})
                      }
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      size='sm'
                      value={detaill?.payment_type_2_desc}
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      size='sm'
                      as='textarea'
                      style={{height: '40px'}}
                      value={detaill?.notes}
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='my-7'>
                  <Col sm={6} className='d-flex '>
                    <Row sm={8} className='d-flex align-items-center'>
                      <p className='fs-6'>{t('termasuk-ppn')}</p>
                    </Row>
                    <Row sm={4} className='d-flex justify-content-start align-items-center ms-4'>
                      <Form.Check
                        reverse
                        name='ppn'
                        type='checkbox'
                        id='ckbox-ppn'
                        checked={detaill?.include_ppn}
                      />
                    </Row>
                  </Col>
                  <Col sm={6} className='d-flex'>
                    <Row sm={8} className='d-flex align-items-center'>
                      <p className=' fs-6'>{t('Formulated Price')}</p>
                    </Row>
                    <Row sm={4} className='d-flex justify-content-start align-items-center ms-4'>
                      <Form.Check
                        reverse
                        name='formula_Price'
                        type='checkbox'
                        id='formula_Price'
                        checked={detaill?.is_formulated_price}
                      />
                    </Row>
                  </Col>
                </Row>
                { detaill?.sector_id != 2 && <>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('alasan perpanjangan')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        aria-label='Default select example'
                        size='sm'
                        value={detaill?.amandement_notes}
                        disabled
                      />
                    </Col>
                  </Row> 
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('tanggal perpanjangan')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        aria-label='Default select example'
                        size='sm'
                        value={detaill?.extension_note}
                        disabled
                      />
                    </Col>
                  </Row>
                </> }
              </Col>
            </Row>
          )}

          {detaill?.sector?.id == 2 && (
            <Row>
              <Col md='6'>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-item')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      size='sm'
                      value={detaill?.id}
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-produsen')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control value={detaill?.produsen?.name} type='text' disabled size='sm' />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      size='sm'
                      value={detaill?.incoterm1?.code}
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      size='sm'
                      value={detaill?.province?.region_name}
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-gudang')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      size='sm'
                      value={detaill?.plant_desc}
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      size='sm'
                      value={detaill?.product_name}
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-kuantum')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      size='sm'
                      value={
                        i18next.language === 'en'
                          ? detaill?.request_quantum?.toLocaleString('en', {
                              maximumFractionDigits: 4,
                            }) + ' Ton'
                          : detaill?.request_quantum?.toLocaleString('id', {
                              maximumFractionDigits: 4,
                            }) + ' Ton'
                      }
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      size='sm'
                      value={detaill?.payment_type_1_desc}
                      disabled
                    />
                  </Col>
                </Row>
              </Col>
              <Col md='6'>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-endUser')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      as='textarea'
                      style={{height: '40px'}}
                      size='sm'
                      value={
                        detaill.end_user_multiple
                          ? handleShowValue(detaill.end_user)
                          : detaill.end_user
                      }
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      size='sm'
                      value={t(detaill?.sector?.name)}
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                  </Col>
                  <Col md={8}>
                    {detaill?.incoterm2 == null ? (
                      <Form.Control
                        size='sm'
                        aria-label='Default select example'
                        value={
                          detaill?.incoterm2_id == null || detaill?.incoterm2_id == '0'
                            ? ''
                            : detaill?.incoterm2_id
                        }
                        disabled
                      />
                    ) : (
                      <Form.Control
                        aria-label='Default select example'
                        size='sm'
                        value={detaill?.incoterm2?.code ? detaill?.incoterm2?.code : ''}
                        disabled
                      />
                    )}
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      size='sm'
                      value={detaill?.city?.city_name}
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      size='sm'
                      value={detaill?.product_type_desc}
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('sub-order-spek')}</p>
                  </Col>
                  <Col md={8}>
                    <FieldProductSpec data={detaill?.product_spec} />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='fs-6 mt-3'>{t('Price')}/Ton</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      size='sm'
                      value={
                        'Rp' + i18next.language === 'en'
                          ? detaill?.request_price?.toLocaleString('en', {maximumFractionDigits: 4})
                          : detaill?.request_price?.toLocaleString('id', {maximumFractionDigits: 4})
                      }
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      size='sm'
                      as='textarea'
                      style={{height: '40px'}}
                      value={detaill?.notes}
                      disabled
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          )}

          {detaill?.sector?.id == 3 && (
            <Row>
              <Col md='6'>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-item')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      size='sm'
                      value={detaill?.id}
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-produsen')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control value={detaill?.produsen?.name} type='text' disabled size='sm' />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      size='sm'
                      value={detaill?.incoterm1?.code}
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      size='sm'
                      value={detaill?.province?.region_name}
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      size='sm'
                      value={detaill?.product_type_desc}
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      size='sm'
                      value={
                        i18next.language === 'en'
                          ? detaill?.request_quantum?.toLocaleString('en', {
                              maximumFractionDigits: 4,
                            }) + ' MT'
                          : detaill?.request_quantum?.toLocaleString('id', {
                              maximumFractionDigits: 4,
                            }) + ' MT'
                      }
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('sub-order-kuantumD')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      size='sm'
                      value={
                        i18next.language === 'en'
                          ? detaill?.fixed_quantum?.toLocaleString('en', {
                              maximumFractionDigits: 4,
                            }) + ' MT'
                          : detaill?.fixed_quantum?.toLocaleString('id', {
                              maximumFractionDigits: 4,
                            }) + ' MT'
                      }
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      size='sm'
                      value={detaill?.payment_type_1_desc}
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('sub-order-spek')}</p>
                  </Col>
                  <Col md={8}>
                    <FieldProductSpec data={detaill?.product_spec} />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      size='sm'
                      as='textarea'
                      style={{height: '40px'}}
                      value={detaill?.notes}
                      disabled
                    />
                  </Col>
                </Row>
              </Col>
              <Col md='6'>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-endUser')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      as='textarea'
                      style={{height: '40px'}}
                      size='sm'
                      value={
                        detaill.end_user_multiple
                          ? handleShowValue(detaill.end_user)
                          : detaill.end_user
                      }
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      size='sm'
                      value={t(detaill?.sector?.name)}
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                  </Col>
                  <Col md={8}>
                    {detaill?.incoterm2 == null ? (
                      <Form.Control
                        size='sm'
                        aria-label='Default select example'
                        value={
                          detaill?.incoterm2_id == null || detaill?.incoterm2_id == '0'
                            ? ''
                            : detaill?.incoterm2_id
                        }
                        disabled
                      />
                    ) : (
                      <Form.Control
                        aria-label='Default select example'
                        size='sm'
                        value={detaill?.incoterm2?.code ? detaill?.incoterm2?.code : ''}
                        disabled
                      />
                    )}
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      size='sm'
                      value={detaill?.city?.city_name}
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      size='sm'
                      value={detaill?.product_name}
                      disabled
                    />
                  </Col>
                </Row>

                <Row className='mb-4'>
                  <Col md={4} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('sub-order-hargaP')}/MT</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      size='sm'
                      value={'USD' + PriceFormater(detaill?.request_price)}
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-hargaD')}/MT</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      size='sm'
                      value={'USD' + PriceFormater(detaill?.fixed_price)}
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='mb-4'>
                  <Col md={4}>
                    <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                  </Col>
                  <Col md={8}>
                    <Form.Control
                      aria-label='Default select example'
                      size='sm'
                      value={detaill?.payment_type_2_desc}
                      disabled
                    />
                  </Col>
                </Row>
                <Row className='my-7'>
                  <Col sm={4} className='d-flex align-items-center'>
                    <p className=' fs-6'>{t('Formulated Price')}</p>
                  </Col>
                  <Col sm={8} className='d-flex justify-content-start align-items-center'>
                    <Form.Check
                      reverse
                      name='formula_Price'
                      type='checkbox'
                      id='formula_Price'
                      checked={detaill?.is_formulated_price}
                    />
                  </Col>
                </Row>
                { detaill?.sector_id != 2 && <>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('alasan perpanjangan')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        aria-label='Default select example'
                        size='sm'
                        value={detaill?.amandement_notes}
                        disabled
                      />
                    </Col>
                  </Row>
                  <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('tanggal perpanjangan')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control
                        aria-label='Default select example'
                        size='sm'
                        value={detaill?.extension_note}
                        disabled
                      />
                    </Col>
                  </Row>
                </> }
              </Col>
            </Row>
          )}
        </Modal.Body>
      </Modal>

      <SIPHistories show={showModalHistory} id={showHistory} onCloseModal={() => setShowModalHistory(false)} />
      <ListHistorySIP showListHistorySIP={showListHistorySIP} setShowListHistorySIP={setShowListHistorySIP} id={showHistory} />
    </StyledCard>
  )
}

export {ApprovalTableSIP}
